import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ClearMultiselectIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='clear-multiselect'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M9.37821 10L5 5.6245L5.62489 5L10 9.3724L14.3751 5L15 5.6245L10.6218 10L15 14.3755L14.3751 15L10 10.6276L5.62489 15L5 14.3755L9.37821 10Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>
	);
};

export default ClearMultiselectIcon;
